import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}><path d="M405.3 106.7v298.7H106.7V106.7h298.6m0-42.7H106.7A42.8 42.8 0 0064 106.7v298.7a42.8 42.8 0 0042.7 42.7h298.7a42.8 42.8 0 0042.7-42.7V106.7C448 83.2 428.8 64 405.3 64z" /></svg>;